import React, { PropsWithChildren, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { useNode } from "@craftjs/core";
import { useLoadFont } from "../../../Settings/page-builder/hooks/loadFont";
import { ExtraStyles } from "../../../Settings/page-builder/utils/transformPageBuilderExtraStyles";

export function TextDropCapDecorator(props: PropsWithChildren): JSX.Element {
    const { extraStyles } = useNode((state) => ({
        extraStyles: state.data.props.extraStyles as { normal: ExtraStyles, hover: ExtraStyles } | undefined
    }));
    const theme = useTheme();
    const loadFont = useLoadFont();
    const backgroundColor = (() => {
        switch (extraStyles?.normal.dropCapStyles?.view) {
            case 'stacked': return extraStyles?.normal.dropCapStyles?.primaryColor ??
                theme.palette.primary.main;
            case 'framed': return extraStyles?.normal.dropCapStyles?.secondaryColor ??
                null;
            default: return null;
        }
    })();
    const color = (() => {
        switch (extraStyles?.normal.dropCapStyles?.view) {
            case 'stacked': {
                if (extraStyles.normal.dropCapStyles.secondaryColor) {
                    return extraStyles.normal.dropCapStyles.secondaryColor;
                }

                if (backgroundColor) {
                    return '#fff';
                }

                return theme.palette.primary.main;
            }
            case 'framed': {
                if (extraStyles.normal.dropCapStyles.primaryColor) {
                    return extraStyles.normal.dropCapStyles.primaryColor;
                }

                if (backgroundColor) {
                    return '#fff';
                }

                return theme.palette.primary.main;
            }
            default: return extraStyles?.normal.dropCapStyles?.primaryColor ??
                theme.palette.primary.main;
        }
    })();
    const borderColor = (() => {
        if (extraStyles?.normal.dropCapStyles?.view === 'framed') {
            return extraStyles?.normal.dropCapStyles?.primaryColor ??
                theme.palette.primary.main;
        }
        return null;
    })();

    useEffect(() => {
        if (extraStyles?.normal.dropCapStyles?.fontFamily) {
            loadFont(extraStyles.normal.dropCapStyles.fontFamily);
        }
    }, [loadFont, extraStyles?.normal.dropCapStyles?.fontFamily]);

    return (
        <Box
            sx={{
                color,
                fontFamily: extraStyles?.normal.dropCapStyles?.fontFamily?.name ?? 'Gotham',
                fontSize: extraStyles?.normal.dropCapStyles?.fontSize ?? '46px',
                fontWeight: extraStyles?.normal.dropCapStyles?.fontWeight,
                fontStyle: extraStyles?.normal.dropCapStyles?.fontStyle,
                textTransform: extraStyles?.normal.dropCapStyles?.textTransform,
                textDecoration: extraStyles?.normal.dropCapStyles?.textDecoration,
                marginInlineEnd: extraStyles?.normal.dropCapStyles?.space ?? '10px',
                lineHeight: extraStyles?.normal.dropCapStyles?.lineHeight ?? 1,
                wordSpacing: extraStyles?.normal.dropCapStyles?.wordSpacing,
                verticalAlign: 'top',
                float: 'left',
                backgroundColor,
                padding: extraStyles?.normal.dropCapStyles?.size ??
                    (
                        extraStyles?.normal.dropCapStyles?.view ?
                            '6px' :
                            undefined
                    ),
                textShadow: extraStyles?.normal.dropCapStyles?.textShadow,
                borderColor,
                borderWidth: extraStyles?.normal.dropCapStyles?.view === 'framed' ? '2px' : undefined,
                borderStyle: extraStyles?.normal.dropCapStyles?.view === 'framed' ? 'solid' : undefined,
                borderRadius: extraStyles?.normal.dropCapStyles?.borderRadius
            }}
            component="span"
        >
            {props.children}
        </Box>
    )
}